import { useSelector } from 'react-redux';

const useIsSuperAdmin = () => {
  const user = useSelector((state) => state.auth.user);
  return user?.userRoles?.some((role) => role.role === 'superAdmin') ?? false;
};

export default useIsSuperAdmin;
